import React from 'react';
import TwitterIcon from '../../../assets/svgs/twitter.svg';
import MatterIcon from '../../../assets/svgs/matter.svg';
import CopyIcon from '../../../assets/svgs/copy.svg';
import EmailIcon from '../../../assets/svgs/email.svg';

const SocialLinks = ({
  classname,
  simpleTwitterShareUrl,
  simpleMatterShareUrl,
  simpleEmailShareUrl,
  handleCopyClick,
  isCopied,
}) => (
  <div className={classname}>
    <a href={simpleTwitterShareUrl} target="_blank" rel="noopener noreferrer">
      <TwitterIcon />
    </a>
    <a href={simpleMatterShareUrl} target="_blank" rel="noopener noreferrer">
      <MatterIcon />
    </a>
    <button onClick={handleCopyClick} style={{ opacity: isCopied ? 0.2 : null }}>
      <CopyIcon />
    </button>
    <a href={simpleEmailShareUrl} target="_blank" rel="noopener noreferrer">
      <EmailIcon />
    </a>
  </div>
);

export default SocialLinks;
